import * as tslib_1 from "tslib";
import axios from "axios";
import xamatron from "xamatron";
export function routeDepth(route) {
    return (route.path == "/") ? 0 : route.path.split("/").length;
}
export function cmp(a, b) {
    return (a < b) ? -1 : (a > b) ? 1 : 0;
}
export function getQueryStringArgs() {
    var e_1, _a;
    var args = {};
    try {
        for (var _b = tslib_1.__values(location.search.substr(1).split(/&/g)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var arg = _c.value;
            var parts = arg.split(/=/, 2);
            args[parts[0]] = parts[1] ? decodeURIComponent(parts[1].replace(/\+/g, " ")) : "";
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return args;
}
export function findDocument(prod, predicate) {
    var e_2, _a, e_3, _b;
    try {
        for (var _c = tslib_1.__values(prod.documents), _d = _c.next(); !_d.done; _d = _c.next()) {
            var cat = _d.value;
            try {
                for (var _e = tslib_1.__values(cat.documents), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var doc = _f.value;
                    if (predicate(doc))
                        return doc;
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return null;
}
export function reportDevicePosition(serial, feature) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var position, pos, err_1, err_2;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    position = {
                        serial: serial,
                        feature: feature,
                        source: "ALLU Mobile Application on " + xamatron.platform,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, xamatron.getCurrentPosition({ timeout: 30000 })];
                case 2:
                    pos = _a.sent();
                    position.latitude = pos.latitude;
                    position.longitude = pos.longitude;
                    position.accuracy = pos.accuracy;
                    position.altitude = pos.altitude;
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    position.error = err_1.code + " " + err_1.message;
                    return [3 /*break*/, 4];
                case 4:
                    _a.trys.push([4, 6, , 7]);
                    return [4 /*yield*/, axios.post("devices/positions", position)];
                case 5:
                    _a.sent();
                    return [3 /*break*/, 7];
                case 6:
                    err_2 = _a.sent();
                    if (window.console)
                        console.log("reportPosition", err_2);
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    });
}
